export default __webpack_public_path__ + "static/6796-ed3d2721c143a8598c638d1f7f496971.jpg";